import { computed, type Ref } from 'vue'
import type { RattachementDTO } from '@/features/api/extranet/dto/Profil'
import type { IconName } from '@designSystem/fondation/icons/iconsList'
import { usePaginatedListState } from '../usePaginatedListState'

export type RattachementVM = {
  id: string
  siretLabel: string
  display: {
    icon: IconName
    title: string
  }
  permissions: RattachementDTO['permissions']
  raw: RattachementDTO
}

export function useRattachementsListState(rattachements: Ref<RattachementDTO[] | null | undefined>) {
  const toRattachementVM = (r: RattachementDTO): RattachementVM => {
    const hasNIC = !!r.entite.nic
    const siretLabel = hasNIC ? `Siret : ${r.entite.siren} ${r.entite.nic}` : `Siren : ${r.entite.siren}`
    return {
      id: `${r.entite.siren}-${r.entite.nic ?? '000'}`,
      siretLabel,
      display: {
        icon: r.typeEntreprise === 'Adherent' ? 'entreprise' : 'bank',
        title: r.entite.denomination,
      },
      permissions: r.permissions,
      raw: r,
    }
  }

  const { currentPage, nbPages, nbPagesMax, vmList, pageVMs, DROPDOWN_PERMS, PERM_TOGGLES } = usePaginatedListState(
    rattachements,
    toRattachementVM,
  )

  const headerFirstCol = computed(() => 'Comptes')

  return { currentPage, nbPages, nbPagesMax, vmList, pageVMs, headerFirstCol, DROPDOWN_PERMS, PERM_TOGGLES }
}
